/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuInputRangeCurrency_itemSearch$ref = any;
type SbSharedRefineMenuPriceRanges_itemSearch$ref = any;
type SbSharedRefineMenuSaleInput_itemSearch$ref = any;
export type SbRespRefineMenuFilterPrice_itemSearch$ref = any;
export type SbRespRefineMenuFilterPrice_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuPriceRanges_itemSearch$ref & SbSharedRefineMenuInputRangeCurrency_itemSearch$ref & SbSharedRefineMenuSaleInput_itemSearch$ref;
    readonly " $refType": SbRespRefineMenuFilterPrice_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenuFilterPrice_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuPriceRanges_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuInputRangeCurrency_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuSaleInput_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '0c6e200de97b0b14bb8a1d33b2d35f80';
export default node;
